var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Card",
    { staticClass: "recommend-app", attrs: { title: "推荐服务" } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: _vm.loading,
              expression: "loading"
            }
          ],
          staticClass: "items"
        },
        [
          _vm._l(_vm.list, function(item, index) {
            return _c(
              "div",
              { key: index, staticClass: "item" },
              [
                item.url
                  ? _c(
                      "a",
                      {
                        staticClass: "pointer",
                        on: {
                          click: function($event) {
                            _vm.$openHome(
                              item.url,
                              item.name,
                              Number(item.type || 1),
                              1
                            )
                          }
                        }
                      },
                      [
                        _c("img", { attrs: { src: item.pic } }),
                        _c("div", { staticClass: "info" }, [
                          _c(
                            "div",
                            { staticClass: "f16 text-overflow info-name" },
                            [_vm._v(_vm._s(item.name))]
                          ),
                          _c("div", { staticClass: "gray6 text-overflow" }, [
                            _vm._v(_vm._s(item.title))
                          ])
                        ]),
                        _c("div", { staticClass: "entry" }, [
                          _c("div", { staticClass: "text-center entry-btn" }, [
                            _vm._v("点击进入")
                          ])
                        ])
                      ]
                    )
                  : [
                      _c("img", { attrs: { src: item.pic } }),
                      _c("div", { staticClass: "info" }, [
                        _c(
                          "div",
                          { staticClass: "f16 text-overflow info-name" },
                          [_vm._v(_vm._s(item.name))]
                        ),
                        _c("div", { staticClass: "gray6 text-overflow" }, [
                          _vm._v(_vm._s(item.title))
                        ])
                      ])
                    ]
              ],
              2
            )
          }),
          _c("div", { staticClass: "item flex-left" }),
          _c("div", { staticClass: "item flex-left" }),
          _c("div", { staticClass: "item flex-left" }),
          _c("div", { staticClass: "item flex-left" }),
          _c("div", { staticClass: "item flex-left" }),
          _c("div", { staticClass: "item flex-left" }),
          _c("div", { staticClass: "item flex-left" }),
          _c("div", { staticClass: "item flex-left" }),
          _c("div", { staticClass: "item flex-left" }),
          _c("div", { staticClass: "item flex-left" })
        ],
        2
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }